import { useEffect } from 'react';

import {
  useAppwatchSelector,
  useAppwatchDispatch,
  PaymentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ChartDisplay } from '@wajeez-web/components/ui';
import { ChartHeader } from '../ChartHeader';
import { ChartsProps } from '../types';

const PromoCodeAliasBreakdownBySourceChart = ({ dates }: ChartsProps) => {
  const dispatch = useAppwatchDispatch();
  const {
    promoCodeAliasBreakdownBySource,

    promoCodeAliasBreakdownBySourceStatus,
  } = useAppwatchSelector((c) => c.paymentAnalysis);

  useEffect(() => {
    dispatch(
      PaymentAnalysisActions.getPromoCodeAliasBreakdownBySourceAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
      })
    );
  }, [dates]);

  return (
    <div className="col-span-2 md:col-span-1">
      {' '}
      <Card>
        <div className="space-y-2">
          <div className="flex flex-row justify-between">
            <ChartHeader
              title="promo Code Alias Breakdown By Source promo Code Alias Breakdown By Source"
              dates={dates}
            />
          </div>

          <ChartDisplay
            noDataText="نطاق التاريخ هذا غير مدعوم للرمز الترويجي"
            loading={promoCodeAliasBreakdownBySourceStatus === 'loading'}
            chartType="bar"
            chart={{
              type: 'bar',
              stacked: true,
            }}
            xaxis={{
              categories: promoCodeAliasBreakdownBySource.map(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                (d) => d.subscription_Period || ''
              ),
            }}
            plotOptions={{
              bar: {
                horizontal: false,
                dataLabels: {
                  total: {
                    enabled: true,
                    offsetX: 0,

                    style: {
                      fontSize: '13px',
                      fontWeight: 900,
                    },
                    formatter: function (w, opt) {
                      return (
                        promoCodeAliasBreakdownBySource[opt.dataPointIndex]
                          .code +
                        ':' +
                        promoCodeAliasBreakdownBySource[opt.dataPointIndex].sum
                      );
                    },
                  },
                },
              },
            }}
            seriesData={[
              {
                name: 'Stripe',
                data:
                  promoCodeAliasBreakdownBySource.map((d) => d.stripe || 0) ||
                  [],
              },
              {
                name: 'Tamara',
                data:
                  promoCodeAliasBreakdownBySource.map((d) => d.tamara || 0) ||
                  [],
              },
              {
                name: 'Moyasar',
                data:
                  promoCodeAliasBreakdownBySource.map((d) => d.moyasar || 0) ||
                  [],
              },
            ]}
          />
        </div>
      </Card>
    </div>
  );
};

export default PromoCodeAliasBreakdownBySourceChart;
